<template>
  <div>
    <a-steps :current="current">
      <a-step v-for="item in steps" :key="item.title" :title="item.title" />
    </a-steps>
    <div class="steps-content">
      <div v-if="current==0">
        <ProjectAddBaseInfo :project="project" />
      </div>
      <div v-if="current==1">
        <div class="m_flex_row" style="margin-left:20px;margin-top:0px;">
          <div class="m_flex_column" style="width:100px;">知情同意书:</div>
          <a-upload
            :data="file_data"
            style="width:500px"
            name="file"
            accept=".pdf"
            :multiple="false"
            :file-list="project.informed_consent"
            :action="uploadURL+1"
            :withCredentials="withCredentials"
            :before-upload="beforeUpload"
            :headers="headers"
            @change="informed_consent_handleChange"
          >
            <a-button>
              <a-icon type="upload" />点击上传
            </a-button>
          </a-upload>
        </div>

        <ProjectAddSS title="入选条件" :SS_data="project.SS_list" @update="SSUpdate" />
        <ProjectAddSS title="排除条件" :SS_data="project.SE_list" @update="SEUpdate" />
        <ProjectAddOtherInfo
          :otherInfoDataList="project.otherInfoDataList"
          @updateOtherInforDataList="updateOtherInforDataList"
        />

        <div class="m_flex_row" style="margin-left:0px;margin-top:30px;margin-bottom:30px;">
          <div class="m_flex_column" style="width:300px;margin-right:20px">是否需要签署过程中进行录音</div>
          <a-radio-group buttonStyle="solid" v-model="project.need_sound" tyle="width:500px">
            <a-radio-button value="1">需要</a-radio-button>
            <a-radio-button value="0">不需要</a-radio-button>
          </a-radio-group>
        </div>

        <div class="m_flex_row" style="margin-left:0px;margin-top:30px;margin-bottom:30px;">
          <div class="m_flex_column" style="width:300px;margin-right:20px">是否需要受试者录像阅读相关文字:</div>
          <a-radio-group buttonStyle="solid" v-model="project.need_video" tyle="width:500px">
            <a-radio-button value="1">必须</a-radio-button>
            <a-radio-button value="0">不必须</a-radio-button>
          </a-radio-group>
        </div>

        <div class="m_flex_row" style="margin-left:0px;margin-top:30px;margin-bottom:30px;">
          <div class="m_flex_column" style="width:300px;margin-right:20px">录像阅读文本:</div>
          <a-input v-model="project.video_text" placeholder="请输入" allowClear style="width:500px" />
        </div>

        <!-- <div class="m_flex_row" style="margin-left:0px;margin-top:30px;margin-bottom:30px;">
          <div class="m_flex_column" style="width:300px;margin-right:20px">更新项目版本是否需要重新签署知情同意书:</div>
          <a-radio-group buttonStyle="solid" v-model="need_video" tyle="width:500px">
            <a-radio-button value="1">必须</a-radio-button>
            <a-radio-button value="0">不必须</a-radio-button>
          </a-radio-group>
        </div>-->
      </div>
      <div v-if="current==2">
        <ProjectAddUnit :project="project" />
      </div>
      <div v-if="current==3">
        <ProjectAddDoctor :doctor_list="project.doctor_list" @updateDoctor="updateDoctor" />
      </div>
      <div v-if="current==4" style="text-align:center">
        <ProjectAddShow :project="project" />
      </div>
    </div>
    <div class="steps-action">
      <a-button v-if="current > 0" style="margin-left:15px;margin-right: 15px" @click="prev">上一步</a-button>
      <a-button v-if="current < steps.length - 1" type="primary" @click="next">下一步</a-button>
      <a-button v-if="current == steps.length - 1" type="primary" @click="handleSubmit">发布项目</a-button>
    </div>
  </div>
</template>

<script>
import request from "../../utils/request";
import Global from "../../global_variable";
import ProjectAddBaseInfo from "@/components/ProjectAddBaseInfo";
import ProjectAddUnit from "@/components/ProjectAddUnit";
import ProjectAddDoctor from "@/components/ProjectAddDoctor";
import ProjectAddShow from "@/components/ProjectAddShow";
import ProjectAddSS from "@/components/ProjectAddSS";
import ProjectAddOtherInfo from "@/components/ProjectAddOtherInfo";

export default {
  components: {
    ProjectAddBaseInfo,
    ProjectAddUnit,
    ProjectAddDoctor,
    ProjectAddShow,
    ProjectAddSS,
    ProjectAddOtherInfo
  },
  data() {
    return {
      project: {
        doctor_list: [],
        name: "",
        plan_number: "",
        sponsor: "",
        introduce: "",
        informed_consent: [
          // {
          //   status: "done",
          //   name: "知情协议书.pdf",
          //   url:
          //     "/api/v1.0/annex/2020/05/21/7997fef8-9b1a-11ea-b33d-0242c0a81004.pdf",
          //   id: "5ec601ac8d021f72626d58b0",
          //   uid: "5ec601ac8d021f72626d58b0"
          // }
        ],
        otherInfoDataList: [
          // {
          //   the_id: 1,
          //   title: "标题",
          //   introduce: "介绍",
          //   need_read: "1",
          //   files_text: "附件.png"
          // }
        ],
        need_video: "0",
        need_sound: "1",
        video_text: "",
        unit_all: [],
        unit_selected_key_list: [],
        unit_seleccted_list: [],
        SS_list: [
          // {
          //   value: "入选条件1",
          //   key: 1
          // }
        ],
        SE_list: [
          // {
          //   value: "排除条件1",
          //   key: 1
          // }
        ]
      },
      current_the_id: -1,
      current: 0,
      steps: [
        {
          title: "基本信息设置"
        },
        {
          title: "知情信息设置"
        },
        {
          title: "单位设置"
        },
        {
          title: "研究者设置"
        },
        {
          title: "发布项目"
        }
      ],

      uploadURL: Global.uploadURL,

      accept: Global.accept,
      //设置上传的请求头部，IE10 以上有效
      headers: {
        authorization: "authorization-text"
      },
      file_data: {
        authority: 500
      },
      //上传请求时是否携带 cookie
      withCredentials: true,
      need_sound: "0",
      unitList: []
    };
  },
  mounted() {
    this.getDetail();
    this.getUnitList();
  },
  methods: {
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!isLt2M) {
        this.$message.error("文件必须小余50M");
      }
      return isLt2M;
    },
    SSUpdate(data, callback) {
      this.project.SS_list = data;
      callback("成功");
    },
    SEUpdate(data, callback) {
      this.project.SE_list = data;
      callback("成功");
    },
    getDetail() {
      let the_id = this.$route.query.the_id;
      if (the_id) {
        request({
          url: "/project/back/detail/" + the_id,
          method: "get",
          params: {}
        }).then(response => {
          let data = response.data;
          if (data.success) {
            this.project = data.data;
            let otherInfoDataList = data.data.item.items;
            let x = 1;
            otherInfoDataList = otherInfoDataList.map(item => {
              item["the_id"] = x;
              x += 1;
              if (item["annexs"]) {
                item["files_text"] = item["annexs"].map(file => {
                  return file.name + "  ";
                });
              } else {
                item["files_text"] = "";
              }
              return item;
            });
            this.project.otherInfoDataList = otherInfoDataList;
            console.log("看看project", this.project);
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
    getUnitList() {
      request({
        url: "/edc_unit/all_no_page",
        method: "get",
        params: {}
      }).then(response => {
        let data = response.data;
        if (data.success) {
          this.project.unit_all = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },

    next() {
      if (this.current == 1) {
        if (this.project.informed_consent.length <= 0) {
          this.$message.error("请上传知情同意书");
          return;
        }
      }
      this.current++;
    },
    prev() {
      this.current--;
    },
    updateOtherInforDataList(data) {
      console.log("updateOtherInforDataList", data);
      this.project.otherInfoDataList = data;
    },
    updateDoctor(data) {
      this.project.doctor_list = data;
      console.log("updateDoctor", data);
    },
    informed_consent_handleChange(info) {
      console.log("informed_consent_handleChange", info);
      if (info.fileList) {
        let informed_consent = [...info.fileList];
        informed_consent = informed_consent.map(file => {
          if (file.response) {
            file.url = file.response.url;
          }
          return file;
        });
        this.project.informed_consent = informed_consent;
        console.log(
          "this.project.informed_consent",
          this.project.informed_consent
        );
      }
    },
    handleSubmit() {
      let the_id = this.$route.query.the_id;
      if (the_id) {
        console.log("去更新");
        request({
          url: "/project/update/" + the_id,
          method: "POST",
          data: {
            name: this.project.name,
            plan_number: this.project.plan_number,
            sponsor: this.project.sponsor,
            introduce: this.project.introduce,
            informed_consent: this.project.informed_consent[0],
            SS_list: this.project.SS_list,
            SE_list: this.project.SE_list,
            need_video: this.project.need_video,
            need_sound: this.project.need_sound,
            video_text: this.project.video_text,
            unit_seleccted_list: this.project.unit_seleccted_list,
            doctor_list: this.project.doctor_list,
            otherInfoDataList: this.project.otherInfoDataList
          }
        }).then(response => {
          let data = response.data;
          if (data.success) {
            this.$message.success(data.msg);
            this.$router.push({ path: "/project/all" });
          } else {
            this.$message.error(data.msg);
          }
          console.log(response);
        });
      } else {
        request({
          url: "/project/add",
          method: "POST",
          data: {
            name: this.project.name,
            plan_number: this.project.plan_number,
            sponsor: this.project.sponsor,
            introduce: this.project.introduce,
            informed_consent: this.project.informed_consent[0],
            SS_list: this.project.SS_list,
            SE_list: this.project.SE_list,
            need_video: this.project.need_video,
            need_sound: this.project.need_sound,
            video_text: this.project.video_text,
            unit_seleccted_list: this.project.unit_seleccted_list,
            doctor_list: this.project.doctor_list,
            otherInfoDataList: this.project.otherInfoDataList
          }
        }).then(response => {
          let data = response.data;
          if (data.success) {
            this.$message.success(data.msg);
            this.$router.push({ path: "/project/all" });
          } else {
            this.$message.error(data.msg);
          }
          console.log(response);
        });
      }

      // this.form.validateFields((err, values) => {
      //   if (!err) {
      //     values.informed_consent =
      //       values.informed_consent.fileList[0].response;
      //     for (let i = 1; i <= this.count; i++) {
      //       console.log("看卡" + i, values);
      //       if (this.closeList.indexOf(i) !== -1) {
      //         values["title_" + i] = "";
      //         values["introduce_" + i] = "";
      //         values["annex_" + i] = "";
      //       } else {
      //         let annex = values["annex_" + i];
      //         if (annex) {
      //           values["annex_" + i] = annex.fileList.map(x => {
      //             console.log("内部x", x, x.response);
      //             return x.response;
      //           });
      //         } else {
      //           values["annex_" + i] = "";
      //         }
      //       }
      //     }
      //     console.log(values);
      //     values["count"] = this.count;
      //     values["standard_selected_count"] = this.StandardSelectedCount;
      //     values["standard_exclude_count"] = this.StandardExcludeCount;
      //     request({
      //       url: "/project/",
      //       method: "POST",
      //       data: values
      //     }).then(response => {
      //       let data = response.data;
      //       if (data.success) {
      //         this.form.resetFields();
      //         this.$message.success(data.msg);
      //         this.$router.push({ path: "/project/all" });
      //       } else {
      //         this.$message.error(data.msg);
      //       }
      //       console.log(response);
      //     });
      //   }
      // });
    }
  }
};
</script>

<style>
.steps-content {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  padding-top: 40px;
  padding-bottom: 80px;
}

.steps-action {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}
</style>